import { Route, Routes } from 'react-router-dom'
import { Suspense } from 'react'
import { ThemeProvider } from 'styled-components'
import globalTheme from 'styles/theme'
import Dashboard from './pages/Dashboard/dashboard'

import LoginComponent from './pages/Login/login'
import SingUp from './pages/signUp/signUP'
import Outstanding from './pages/Listing/outStanding'
import ForgotPasswordComponent from './pages/Forgot Password/forgotPassword'

function AppRoutes() {
  return (
    <>
      <Suspense fallback={<div className="container"></div>}>
        <ThemeProvider theme={globalTheme}>
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/sing-up" element={<SingUp />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/listing" element={<Outstanding />} />
            <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
          </Routes>
        </ThemeProvider>
      </Suspense>
    </>
  )
}

export default AppRoutes
